function InitFormPopupLp() {
  window.addEventListener("load", function () {
    const closeBtnsLp = document.querySelectorAll(".closeFormPopupLp");
    const popupWrapperLp = document.querySelector(".lpFormPopupWrapper");
    const popupOverlay = document.querySelector(".formPopupOverlay");

    if (!popupWrapperLp || !popupOverlay) return;

    setTimeout(() => {
      popupWrapperLp.classList.add("active");
      popupOverlay.classList.add("active");
      document.documentElement.classList.add("overflow-hidden");
    }, 4000);

    closeBtnsLp.forEach((btn) => {
      btn.addEventListener("click", function (e) {
        e.preventDefault();
        popupWrapperLp.classList.remove("active");
        popupOverlay.classList.remove("active");
        document.documentElement.classList.remove("overflow-hidden");
      });
    });

    popupOverlay.addEventListener("click", function () {
      popupWrapperLp.classList.remove("active");
      popupOverlay.classList.remove("active");
      document.documentElement.classList.remove("overflow-hidden");
    });
  });
}

export default InitFormPopupLp;
